<!-- <div class="disclaimerInfo">
    <h2 [appTranslate]="'APP_HEADER_TITLE'"></h2>
    <p [appTranslate]="'APP_HEADER_DESCRIPTION'"></p>
</div> -->
<div class="info-text-payments withTitle" role="main" aria-label="License application page">
    <img src="../assets/images/parking-info.svg" alt="" aria-hidden="true" />
    <div class="info-text-content">
        <h3 [appTranslate]="'APP_HEADER_TITLE'"></h3>
        <span [appTranslate]="'APP_HEADER_DESCRIPTION'"></span>
    </div>
</div>

<div class="profile-header">
    <h2 [appTranslate]="'APPLY_FOR_LICENSE'"></h2>
    <button type="button" (click)="logout()" class="btn btn-logout" aria-label="Logout">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true">
            <path
                d="M8.90039 7.56023C9.21039 3.96023 11.0604 2.49023 15.1104 2.49023H15.2404C19.7104 2.49023 21.5004 4.28023 21.5004 8.75023V15.2702C21.5004 19.7402 19.7104 21.5302 15.2404 21.5302H15.1104C11.0904 21.5302 9.24039 20.0802 8.91039 16.5402"
                stroke="#072F51" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M15.0001 12H3.62012" stroke="#072F51" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            <path d="M5.85 8.6499L2.5 11.9999L5.85 15.3499" stroke="#072F51" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
        </svg>

        <span [appTranslate]="'LOGOUT'"></span>
    </button>
</div>

<div class="topStepper">
    <ul aria-label="Application steps">
        <li [attr.aria-current]="currentStep==1 ? 'step' : null"
            [ngClass]="{'current':currentStep==1, 'filled':sideModel.ParkingTypeName||sideModel.PermitTypeName||sideModel.ZoneInfoName||sideModel.ZoneInfoName||sideModel.ParkingGarageName}">
            <div class="stepBubble">
                <span class="step-icon step-1"></span>
            </div>
            <span class="line" [appTranslate]="'CHOOSE'"></span>
            <p [appTranslate]="'LICENSE_TYPE'"></p>
        </li>
        <li [attr.aria-current]="currentStep==2 ? 'step' : null"
            [ngClass]="{'current':currentStep==2, 'filled':appModel.Name||appModel.Surname||appModel.Street||appModel.Phone||appModel.City||appModel.Email}">
            <div class="stepBubble">
                <span class="step-icon step-2"></span>
            </div>
            <span class="line" [appTranslate]="'FILL_IN'"></span>
            <p [appTranslate]="'PERSONAL_DATA'"></p>
        </li>
        <li [attr.aria-current]="currentStep==3 ? 'step' : null"
            [ngClass]="{'current':currentStep==3 , 'filled':appModel.IdFiles.length != 0 || appModel.DriversLicences.length != 0 || appModel.TrafficLicences.length != 0 }">
            <div class="stepBubble">
                <span class="step-icon step-3"></span>
            </div>
            <span class="line" [appTranslate]="'ATTACH'"></span>
            <p [appTranslate]="'DOCUMENTS'"></p>
        </li>

        <li [attr.aria-current]="currentStep==4 ? 'step' : null" [ngClass]="{'current':currentStep==4}">
            <div class="stepBubble">
                <span class="step-icon step-4"></span>
            </div>

            <span class="line" [appTranslate]="'SEND'"></span>
            <p [appTranslate]="'CONFIRMATION'"></p>
        </li>
    </ul>
</div>

<div>
    <div class="singleStep" *ngIf="currentStep==1">
        <div class="profile-section">
            <div class="form-row">
                <div class="form-group">
                    <h2 [appTranslate]="'CHOOSE_CITY'" class="mt-0"></h2>
                </div>

                <div class="form-group smallerWidth">
                    <select type="text" name="city" class="form-control hasDropdown" [(ngModel)]="appModel.CityId"
                        (ngModelChange)="onCityChange()" [disabled]="disableFields">
                        <option *ngFor="let city of cities" [value]="city.Id">{{city.Name}}</option>
                    </select>
                    <small *ngIf="!appModel.CityId && !firstStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
                    <div class="disclaimerApply">
                        <img src="/assets/images/info.svg" alt="" aria-hidden="true">
                        <span [appTranslate]="'PARKING_DISCLAIMER'"></span>
                    </div>
                </div>
            </div>
        </div>

        <div class="profile-section">
            <h2 [appTranslate]="'CHOOSE_PARKING_TYPE'"></h2>
            <div class="radio-group">
                @for (item of parkingTypes; track item.Name; let i = $index) {
                <div class="custom-radio" [attr.data-icon]="$index"
                    [ngClass]="{'active':appModel.ParkingTypeId==item.Id, 'disabled':!appModel.CityId}">
                    <input type="radio" name="parkingType" [value]="item.Id" [(ngModel)]="appModel.ParkingTypeId"
                        (ngModelChange)="onParkingChange(item)" [disabled]="!appModel.CityId ||disableFields">
                    <span>{{item.Name}}</span>
                </div>
                }
            </div>
            <small *ngIf="!forbiddenElectric && !firstStepValid">За избраниот паркинг не е дозволено издавање на
                дозволи за ваков тип на гориво. Ве молиме изберете друг паркинг. </small>
            <small *ngIf="!appModel.ParkingTypeId && !firstStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
        </div>

        <div class="profile-section">

            <div class="form-row">
                <div class="form-group">
                    <h2 [appTranslate]="'CHOOSE_LICENSE_TYPE'" class="m-0"></h2>
                </div>
                <div class="form-group smallerWidth">
                    <select type="text" name="permitType" class="form-control hasDropdown" [(ngModel)]="permitModel"
                        (ngModelChange)="onPermitTypeChange()" [disabled]="!parkingTypeId" [disabled]="disableFields">
                        <!-- <option value="" disabled selected></option> -->
                        <option *ngFor="let permit of permitTypes" [value]="permit.PermitTypeId">{{permit.Name}}
                        </option>
                    </select>
                    <small *ngIf="description" class="description">
                        {{description}}
                    </small>
                    <small *ngIf="!permitModel && !firstStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
                </div>
                <!-- <div class="form-group">
                    <span>Месечна претплата за станар кој со своето живеалиште гравитира на јавната површина наменета за
                        паркирање (прво/второ возило)</span>
                    <div class="price-wrap" *ngIf="appModel.Price!=null">
                        <p>Цена (за едно возило):</p> <span>{{appModel.Price}}</span><span
                            [appTranslate]="'DENARS'"></span>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="profile-section">
            <h2 [appTranslate]="'CHOOSE_ZONE'"></h2>
            <div class="radio-group zone">
                @for (item of chosenPermitLots; track item.ParkingTypeName) {
                <div class="custom-radio" [ngClass]="{'active':appModel.ParkingLotId==item.ParkingTypeId}">
                    <input type="radio" name="zone" [value]="item.ParkingTypeId" [disabled]="disableFields"
                        [(ngModel)]="appModel.ParkingLotId" (ngModelChange)="onLotChange(item)">
                    <span>{{item.ParkingTypeName}}</span>
                </div>
                }
            </div>
            <small *ngIf="!appModel.ParkingLotId && !firstStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
        </div>

        <div class="profile-section noBorder">
            <div class="applicationHeader">
                <h2 [appTranslate]="'ENTER_VEHICALS'"></h2>
                <div class="appWarningMsg" *ngIf="!duplicateRegistration && !firstStepValid">
                    <img src="/assets/images/app-warning.svg" alt="" aria-hidden="true" />
                    <span [appTranslate]="'VEHICLE_REGISTRATION_IS_SOME'">*</span>
                </div>
            </div>

            <div class="carsWrapper">
                <div class="group" *ngFor="let car of appModel.Vehicles; index as i">
                    <div class="car-header">
                        <div class="car-title">
                            <img src="/assets/images/car.svg" alt="" aria-hidden="true" />
                            <span [appTranslate]="'VEHICLE'"></span>
                            <span>{{i+1}}</span>
                        </div>
                        <button *ngIf="i!=0" class="btn btn-link" type="button" (click)="deleteVehicle(i)"><span
                                [appTranslate]="'DELETE'"></span></button>
                    </div>
                    <div class="form-group">
                        <label class="form-group-lbl" [for]="'vehicle-registration-' + i"><span
                                [appTranslate]="'LICENSE_PLATE'"></span></label>
                        <input [id]="'vehicle-registration-' + i" type="text" class="form-control" name="Registration"
                            [value]="car.Registration" [(ngModel)]="car.Registration" maxlength="30"
                            oninput="this.value = this.value.toUpperCase()">
                        <small *ngIf="!car.Registration && !firstStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
                    </div>
                    <div class="form-group">
                        <label class="form-group-lbl" [for]="'vehicle-model-' + i"><span
                                [appTranslate]="'INSERT_MODEL'"></span></label>
                        <input [id]="'vehicle-model-' + i" type="text" class="form-control" name="Model"
                            [value]="car.Model" [(ngModel)]="car.Model" maxlength="30" change="checkPrice()">
                        <small *ngIf="!car.Model && !firstStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
                    </div>
                    <div class="form-group">
                        <label class="form-group-lbl" [for]="'vehicle-fuel-type-' + i"><span
                                [appTranslate]="'FUEL_TYPE'"></span></label>
                        <select [id]="'vehicle-fuel-type-' + i" type="text" name="FuelType"
                            class="form-control hasDropdown" [(ngModel)]="car.FuelType">
                            <option [value]=1><span [appTranslate]="'Petrol'"></span></option>
                            <option [value]=2><span [appTranslate]="'Diesel'"></span></option>
                            <option [value]=3><span [appTranslate]="'HybridPetrolElectric'"></span></option>
                            <option [value]=4><span [appTranslate]="'PetrolCNG'"></span></option>
                            <option [value]=5><span [appTranslate]="'PetrolLPG'"></span></option>
                            <option [value]=6><span [appTranslate]="'Electric'"></span></option>
                            <option [value]=7><span [appTranslate]="'CNG'"></span></option>
                        </select>
                        <small *ngIf="car.FuelType==0 && !firstStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
                    </div>
                </div>

                <div class="group addWrap">
                    <div class="car-header">
                        <div class="car-title">
                            <img src="/assets/images/car.svg" alt="" aria-hidden="true" />
                            <span [appTranslate]="'VEHICLE'"></span>
                        </div>
                    </div>
                    <div class="innerBox">
                        <button type="button" class="btn btn-add" (click)="addNewVehicle()">
                            <img src="/assets/images/add.svg" alt="" aria-hidden="true" />
                            <span [appTranslate]="'ADD_VEHICLE'"></span>
                        </button>
                        <!-- <p>Месечна доплата за трето возило е 300 денари.</p> -->
                    </div>
                </div>
            </div>

            <div class="step-total-summary" *ngIf="appModel.Price !== null">
                <span class="step-total-label" [appTranslate]="'TOTAL'"></span>
                <div class="step-total-amount">
                    <span>{{appModel.Price}}</span>
                    <span [appTranslate]="'DENARS'"></span>
                </div>
            </div>

        </div>

        <small *ngIf="this.errorsMessages">{{this.errorsMessages}}</small>

        <div class="profile-actions">
            <button [appTranslate]="'NEXT_STEP'" (click)="validateFirstStep()" type="button" class="btn btn-primary"
                aria-label="Next step"></button>
        </div>
    </div>

    <div class="singleStep" *ngIf="currentStep==2">
        <div class="profile-section">
            <div class="form-row">
                <div class="form-group">
                    <h2 [appTranslate]="'PERSONAL_DATA'" class="mt-0"></h2>
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <label class="form-group-lbl" for="applicant-name"><span [appTranslate]="'NAME'"></span>
                            {{"*"}}</label>
                        <input id="applicant-name" type="text" class="form-control" name="name"
                            [(ngModel)]="appModel.Name" maxlength="50" appEnglishToCyrillic>
                        <small *ngIf="!appModel.Name && !secondStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
                    </div>

                    <div class="form-group mt-20">
                        <label class="form-group-lbl" for="applicant-surname"><span [appTranslate]="'SURNAME'"></span>
                            {{"*"}}</label>
                        <input id="applicant-surname" type="text" class="form-control" name="surname"
                            [(ngModel)]="appModel.Surname" maxlength="50" appEnglishToCyrillic>
                        <small *ngIf="!appModel.Surname && !secondStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
                    </div>
                </div>
            </div>
        </div>

        <div class="profile-section">
            <div class="form-row">
                <div class="form-row">
                    <div class="form-group">
                        <h2 [appTranslate]="'ADDRESS'" class="mt-0"></h2>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-row">
                        <div class="form-group">
                            <label class="form-group-lbl" for="applicant-street"> <span
                                    [appTranslate]="'STREET'"></span> {{"*"}} </label>
                            <input id="applicant-street" type="text" class="form-control" name="addressId"
                                [(ngModel)]="appModel.Street" maxlength="50">
                            <small *ngIf="!appModel.Street && !secondStepValid"
                                [appTranslate]="'REQUIRED_FIELD'"></small>
                        </div>

                        <div class="form-group">
                            <label class="form-group-lbl" for="applicant-street-number"> <span
                                    [appTranslate]="'NUMBER'"></span> {{"*"}} </label>
                            <input id="applicant-street-number" type="text" class="form-control" name="numberId"
                                [(ngModel)]="appModel.StreetNum" maxlength="20">
                            <small *ngIf="!appModel.StreetNum && !secondStepValid"
                                [appTranslate]="'REQUIRED_FIELD'"></small>
                        </div>

                    </div>
                    <div class="form-group mt-20">
                        <label class="form-group-lbl" for="applicant-city"> <span [appTranslate]="'CITY'"></span>
                            {{"*"}} </label>
                        <input id="applicant-city" type="text" class="form-control" name="cityId"
                            [(ngModel)]="appModel.City" maxlength="30">
                        <small *ngIf="!appModel.City && !secondStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
                    </div>
                </div>
            </div>
            <div class="form-row mt-20">
                <div class="form-group">
                    <h2 [appTranslate]="'CONTACT_DATA'" class="mt-0"></h2>
                </div>
                <div class="form-group">
                    <div class="form-group">
                        <label class="form-group-lbl" for="applicant-phone"> <span
                                [appTranslate]="'PHONE_NUMBER'"></span> {{"*"}}
                        </label>
                        <input id="applicant-phone" type="text" class="form-control" name="phone"
                            [(ngModel)]="appModel.Phone" maxlength="12" (keypress)="numberOnly($event)">
                    </div>
                    <small *ngIf="!appModel.Phone && !secondStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>

                    <div class="form-group mt-20">
                        <label class="form-group-lbl" for="applicant-email"><span [appTranslate]="'EMAIL'"></span> <span
                                *ngIf="!isAdmin">
                                {{"*"}} </span></label>
                        <input id="applicant-email" type="email" (ngModelChange)="emailChanged($event)"
                            class="form-control" name="email" [(ngModel)]="appModel.Email" maxlength="50">
                    </div>
                    <small *ngIf="!isAdmin && !appModel.Email && !secondStepValid"
                        [appTranslate]="'REQUIRED_FIELD'"></small>

                    <div class="error-feedback" *ngIf="!emailValid && !secondStepValid"><span
                            [appTranslate]="'EMAIL_NOT_VALID'"></span>
                    </div>
                </div>
            </div>
        </div>

        <div class="profile-actions jusitfy-content-between">
            <button [appTranslate]="'BACK'" type="button" (click)="goToStep(1)" class="btn btn-next"
                aria-label="Back"></button>
            <button [appTranslate]="'NEXT_STEP'" type="button" (click)="validateSecondStep()" class="btn btn-primary"
                aria-label="Next step"></button>
        </div>
    </div>

    <div class="singleStep" *ngIf="currentStep==3">
        <div class="profile-section">
            <div class="form-row">
                <div class="form-group">
                    <h2 [appTranslate]="'DOCUMENTS'" class="mt-0"></h2>
                </div>
                <div class="form-group">
                    <div class="disclaimerApply">
                        <img src="/assets/images/info.svg" alt="" aria-hidden="true">
                        <span [appTranslate]="'DOCUMENT_DISCLAIMER'"></span>
                    </div>
                </div>
            </div>
            <div class="form-group">
                <label class="file-label" for="id-upload-input">
                    <span [appTranslate]="'ID'"></span>
                </label>

                <div class="drop-zone" (click)="idUpload.click()" (keydown.enter)="idUpload.click()"
                    (keydown.space)="idUpload.click(); $event.preventDefault()" role="button" tabindex="0"
                    aria-label="Upload identification documents" (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)" (drop)="onDrop($event, 'id')">
                    <div class="drop-icon">
                        <img src="/assets/images/document-upload.svg" alt="Upload File">
                    </div>
                    <div class="drop-text">
                        <span [appTranslate]="'DRAG_AND_DROP'"></span>
                        <span class="drop-link" [appTranslate]="'CHOOSE_FILE'"></span>
                    </div>
                </div>

                <div class="file-list">
                    <div class="file-item" *ngFor="let file of appModel.IdFiles; let i = index">
                        <div class="file-item-icon">
                            <img src="/assets/images/document-checkmark.svg" alt="Uploaded">
                        </div>
                        <div class="file-item-info">
                            <div class="file-item-name">{{ file.name }}</div>
                            <div class="file-item-size">{{ getFileSize(file.size) }}</div>
                        </div>

                        <button type="button" class="file-item-remove" (click)="removeIdFiles(i)"
                            aria-label="Remove uploaded file">
                            <img src="/assets/images/clear.svg" alt="" aria-hidden="true">
                        </button>
                    </div>
                </div>

                <input id="id-upload-input" type="file" name="idUpload" #idUpload class="hidden"
                    accept="application/pdf,image/jpeg" (change)="multipleFilesSelect($event, 'id')" multiple>
                <small class="req_text" *ngIf="appModel.IdFiles.length == 0 && !thirdStepValid"
                    [appTranslate]="'REQUIRED_FIELD'"></small>
            </div>

            <div class="form-group mt-60">
                <label class="file-label" for="driver-upload-input">
                    <span [appTranslate]="'DRIVERS_LICENSE'"></span>
                </label>

                <div class="drop-zone" (click)="driverUpload.click()" (keydown.enter)="driverUpload.click()"
                    (keydown.space)="driverUpload.click(); $event.preventDefault()" role="button" tabindex="0"
                    aria-label="Upload driver license documents" (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)" (drop)="onDrop($event, 'driver')">
                    <div class="drop-icon">
                        <img src="/assets/images/document-upload.svg" alt="Upload File">
                    </div>
                    <div class="drop-text">
                        <span [appTranslate]="'DRAG_AND_DROP'"></span>
                        <span class="drop-link" [appTranslate]="'CHOOSE_FILE'"></span>
                    </div>
                </div>

                <div class="file-list">
                    <div class="file-item" *ngFor="let file of appModel.DriversLicences; let i = index">
                        <div class="file-item-icon">
                            <img src="/assets/images/document-checkmark.svg" alt="Uploaded">
                        </div>
                        <div class="file-item-info">
                            <div class="file-item-name">{{ file.name }}</div>
                            <div class="file-item-size">{{ getFileSize(file.size) }}</div>
                        </div>
                        <button type="button" class="file-item-remove" (click)="removeDriversLicencesFiles(i)"
                            aria-label="Remove uploaded file">
                            <img src="/assets/images/clear.svg" alt="" aria-hidden="true">
                        </button>
                    </div>
                </div>

                <input id="driver-upload-input" type="file" name="driverUpload" #driverUpload class="hidden"
                    accept="application/pdf,image/jpeg" (change)="multipleFilesSelect($event, 'driver')" multiple>
                <small class="req_text" *ngIf="appModel.DriversLicences.length == 0 && !thirdStepValid"
                    [appTranslate]="'REQUIRED_FIELD'"></small>
            </div>

            <div class="form-group mt-60">
                <label class="file-label" for="traffic-upload-input">
                    <span [appTranslate]="'TRAFFIC_LICENSE'"></span>
                </label>

                <div class="drop-zone" (click)="traficUpload.click()" (keydown.enter)="traficUpload.click()"
                    (keydown.space)="traficUpload.click(); $event.preventDefault()" role="button" tabindex="0"
                    aria-label="Upload traffic license documents" (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)" (drop)="onDrop($event, 'trafic')">
                    <div class="drop-icon">
                        <img src="/assets/images/document-upload.svg" alt="Upload File">
                    </div>
                    <div class="drop-text">
                        <span [appTranslate]="'DRAG_AND_DROP'"></span>
                        <span class="drop-link" [appTranslate]="'CHOOSE_FILE'"></span>
                    </div>
                </div>

                <div class="file-list">
                    <div class="file-item" *ngFor="let file of appModel.TrafficLicences; let i = index">
                        <div class="file-item-icon">
                            <img src="/assets/images/document-checkmark.svg" alt="Uploaded">
                        </div>
                        <div class="file-item-info">
                            <div class="file-item-name">{{ file.name }}</div>
                            <div class="file-item-size">{{ getFileSize(file.size) }}</div>
                        </div>
                        <button type="button" class="file-item-remove" (click)="removeTrafficLicencesFiles(i)"
                            aria-label="Remove uploaded file">
                            <img src="/assets/images/clear.svg" alt="" aria-hidden="true">
                        </button>
                    </div>
                </div>

                <input id="traffic-upload-input" type="file" name="traficUpload" #traficUpload class="hidden"
                    accept="application/pdf,image/jpeg" (change)="multipleFilesSelect($event, 'trafic')" multiple>
                <small class="req_text" *ngIf="appModel.TrafficLicences.length == 0 && !thirdStepValid"
                    [appTranslate]="'REQUIRED_FIELD'"></small>
            </div>
            <div class="form-group mt-60" *ngIf="chosenPermit.AdditionInfoForDocuments?.trim()">
                <label class="file-label" for="additionMandatoryFiles-upload-input">
                    <span [appTranslate]="'ADDITION_MANDATORY_FILES'"></span>
                </label>
                <div>
                    <div [innerHTML]="chosenPermit.AdditionInfoForDocuments"></div>
                </div>
                <div class="drop-zone" (click)="additionMandatoryFiles.click()"
                    (keydown.enter)="additionMandatoryFiles.click()"
                    (keydown.space)="additionMandatoryFiles.click(); $event.preventDefault()" role="button" tabindex="0"
                    aria-label="Upload traffic license documents" (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)" (drop)="onDrop($event, 'additionMandatory')">
                    <div class="drop-icon">
                        <img src="/assets/images/document-upload.svg" alt="Upload File">
                    </div>
                    <div class="drop-text">
                        <span [appTranslate]="'DRAG_AND_DROP'"></span>
                        <span class="drop-link" [appTranslate]="'CHOOSE_FILE'"></span>
                    </div>
                </div>

                <div class="file-list">
                    <div class="file-item" *ngFor="let file of appModel.AdditionMandatoryFiles; let i = index">
                        <div class="file-item-icon">
                            <img src="/assets/images/document-checkmark.svg" alt="Uploaded">
                        </div>
                        <div class="file-item-info">
                            <div class="file-item-name">{{ file.name }}</div>
                            <div class="file-item-size">{{ getFileSize(file.size) }}</div>
                        </div>
                        <button type="button" class="file-item-remove" (click)="removeAdditionMandatoryFiles(i)"
                            aria-label="Remove uploaded file">
                            <img src="/assets/images/clear.svg" alt="" aria-hidden="true">
                        </button>
                    </div>
                </div>

                <input id="additionMandatoryFiles-upload-input" type="file" name="additionMandatoryFiles"
                    #additionMandatoryFiles class="hidden" accept="application/pdf,image/jpeg"
                    (change)="multipleFilesSelect($event, 'additionMandatory')" multiple>
                <small class="req_text" *ngIf="appModel.AdditionMandatoryFiles.length == 0 && !thirdStepValid"
                    [appTranslate]="'REQUIRED_FIELD'"></small>
            </div>

            <small [appTranslate]="'ALLOWED_FORMATS'"></small>
            <div class="yellowDisclaimer">
                <div class="dislaimerHeader">
                    <img src="/assets/images/warning-icon.svg" alt="" aria-hidden="true">
                    <span [appTranslate]="'WARNING'"></span>
                </div>
                <div class="disclaimerBody">
                    <span [appTranslate]="'ADDRESS_MISMATCH_DISCLAIMER'"></span>
                </div>
            </div>
        </div>

        <div class="profile-section">
            <div class="form-group">
                <h2 [appTranslate]="'ADDITIONAL_INFO'" class="mt-0"></h2>
            </div>
            <div class="form-group">
                <label class="custom-radio">
                    <input type="checkbox" name="docTypeTraffic" [(ngModel)]="appModel.IsTrafficeLicenceOnAddress">
                    <span class="radio-circle"></span>
                    <span [appTranslate]="'LICENSE_NOT_ON_ADDRESS'"></span>
                </label>
                <div *ngIf="appModel.IsTrafficeLicenceOnAddress">
                    <div [innerHTML]="chosenPermit.AdditionInfoForDocuments1"></div>
                </div>
                <label class="custom-radio">
                    <input type="checkbox" name="docTypeId" [(ngModel)]="appModel.IsIdFileOnAddress">
                    <span class="radio-circle"></span>
                    <span [appTranslate]="'ID_NOT_ON_ADDRESS'"></span>
                </label>

                <div *ngIf="appModel.IsIdFileOnAddress">
                    <div [innerHTML]="chosenPermit.AdditionInfoForDocuments2"></div>
                </div>
            </div>
            <div class="form-group mt-60">

                <label class="file-label column" for="additional-heirs-upload-input">
                    <span [appTranslate]="'AND_ATTACH_THE_REQUESTED_DOCUMENTS'"></span>
                </label>
                {{appModel.IsIdFileOnAddress}}
                <div class="drop-zone"
                     [class.disabled]="!appModel.IsIdFileOnAddress && !appModel.IsTrafficeLicenceOnAddress"
                    (click)="(appModel.IsIdFileOnAddress || appModel.IsTrafficeLicenceOnAddress) && multiUpload.click()"
                    (keydown.enter)="(appModel.IsIdFileOnAddress || appModel.IsTrafficeLicenceOnAddress) && multiUpload.click()"
                    (keydown.space)="(appModel.IsIdFileOnAddress || appModel.IsTrafficeLicenceOnAddress) && multiUpload.click();$event.preventDefault()"
                    role="button"
                    tabindex="0"
                    aria-label="Upload additional documents"
                    (dragover)="(appModel.IsIdFileOnAddress || appModel.IsTrafficeLicenceOnAddress) && onDragOver($event)"
                    (dragleave)="(appModel.IsIdFileOnAddress || appModel.IsTrafficeLicenceOnAddress) && onDragLeave($event)"
                    (drop)="(appModel.IsIdFileOnAddress || appModel.IsTrafficeLicenceOnAddress) && onDrop($event, 'other')">

                    <div class="drop-icon">
                        <img src="/assets/images/document-upload.svg" alt="Upload File">
                    </div>
                    
                    <div class="drop-text">
                            <span [appTranslate]="'DRAG_AND_DROP'"></span>
                            <span class="drop-link" [appTranslate]="'CHOOSE_FILE'"></span>
                    </div>
                </div>

                <div class="file-list">
                    <div class="file-item" *ngFor="let file of appModel.AdditionalFiles; let i = index">
                        <div class="file-item-icon">
                            <img src="/assets/images/document-checkmark.svg" alt="Uploaded">
                        </div>
                        <div class="file-item-info">
                            <div class="file-item-name">{{ file.name }}</div>
                            <div class="file-item-size">{{ getFileSize(file.size) }}</div>
                        </div>
                        <button type="button" class="file-item-remove" (click)="removeAdditionalFiles(i)"
                            aria-label="Remove uploaded file">
                            <img src="/assets/images/clear.svg" alt="" aria-hidden="true">
                        </button>
                    </div>
                </div>

                <input id="additional-heirs-upload-input"  [disabled]="!appModel.IsIdFileOnAddress && !appModel.IsTrafficeLicenceOnAddress" type="file" name="additionalHeirsUpload" #multiUpload
                    class="hidden" accept="application/pdf" (change)="multipleFilesSelect($event, 'other')" multiple>
            </div>
        </div>
        <div class="errors error-messages errorReason" *ngIf="!thirdStepValid">
            <p class="mainErrorReason" [appTranslate]="'REQUIRED_FIELD'"></p>
        </div>

        <div class="profile-actions jusitfy-content-between">
            <button [appTranslate]="'BACK'" type="button" (click)="goToStep(2)" class="btn btn-next"
                aria-label="Back"></button>
            <button [appTranslate]="'NEXT_STEP'" type="button" (click)="validateThirdStep()" class="btn btn-primary"
                aria-label="Next step"></button>
        </div>
    </div>


    <div class="singleStep" *ngIf="currentStep==4">

        <div class="profile-section noBorder">
            <div class="form-row">
                <div class="form-group">
                    <h2 [appTranslate]="'FINAL_INFO_CONFIRMATION'" class="mt-0"></h2>
                </div>
            </div>
            <div class="FinalModel mt-20">
                <div>
                    <h2 [appTranslate]="'LICENSE_TYPE'" class="mt-0"></h2>
                    <div class="model-row">
                        <span [appTranslate]="'LICENSE_TYPE'"></span>
                        <b>{{sideModel.PermitTypeName}}</b>
                    </div>
                    <div class="model-row">
                        <span [appTranslate]="'PARKING_TYPE'"></span>
                        <b>{{sideModel.ParkingTypeName}}</b>
                    </div>
                    <div class="model-row">
                        <span [appTranslate]="'ZONE'"></span>
                        <b>{{sideModel.LotName}}</b>
                    </div>
                    <div class="model-row">
                        <span [appTranslate]="'MONTHLY_PAY'"></span>
                        <div class="flex center gap5">
                            <b>{{appModel.Price}}</b>
                            <b [appTranslate]="'DENARS'"></b>
                        </div>
                    </div>
                    @for(car of appModel.Vehicles; track car){
                    <div class="model-row">
                        <span [appTranslate]="'VEHICLE'"> {{$index+1}}</span>
                        <b>{{car.Model}} {{car.Registration}}</b>
                    </div>
                    }

                    <div class="model-row summary">
                        <span [appTranslate]="'TOTAL'"></span>
                        <div class="flex center gap5">
                            <b>{{appModel.Price}}</b> <b [appTranslate]="'DENARS'"></b>
                        </div>
                    </div>
                </div>
                <div>
                    <h2 [appTranslate]="'PERSONAL_DATA'"></h2>
                    <div class="model-row">
                        <span [appTranslate]="'NAME_SURNAME'"></span>
                        <b>{{appModel.Name}} {{appModel.Surname}}</b>
                    </div>
                    <div class="model-row">
                        <span [appTranslate]="'ADDRESS'"></span>
                        <b>{{appModel.Street}} {{appModel.StreetNum}}</b>
                    </div>
                    <div class="model-row">
                        <span [appTranslate]="'CITY'"></span>
                        <b>{{appModel.City}}</b>
                    </div>
                    <div class="model-row">
                        <span [appTranslate]="'EMAIL'"></span>
                        <b>{{appModel.Email}}</b>
                    </div>
                </div>

                <div>
                    <h2 [appTranslate]="'DOCUMENTS'"></h2>
                    <div class="model-row documents">
                        <span [appTranslate]="'ID'"></span>
                        <div class="flex center gap10">
                            <div class="imageWrapper">
                                @for(id_file of appModel.IdFiles; track id_file){
                                <div class="imagePlaceholder"></div>
                                <b>{{id_file.name}} </b>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="model-row documents">
                        <span [appTranslate]="'DRIVERS_LICENSE'"></span>
                        <div class="flex center gap10">
                            <div class="imageWrapper">
                                @for(id_file of appModel.DriversLicences; track id_file){
                                <div class="imagePlaceholder"></div>
                                <b>{{id_file.name}} </b>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="model-row documents">
                        <span [appTranslate]="'TRAFFIC_LICENSE'"></span>
                        <div class="flex center gap10">
                            <div class="imageWrapper">
                                @for(id_file of appModel.TrafficLicences; track id_file){
                                <div class="imagePlaceholder"></div>
                                <b>{{id_file.name}} </b>
                                }
                            </div>
                        </div>

                    </div>
                    <div class="model-row documents" *ngIf="chosenPermit.AdditionInfoForDocuments?.trim()">
                        <span [appTranslate]="'ADDITION_MANDATORY_FILES'"></span>
                        <div class="flex center gap10">
                            <div class="imageWrapper">
                                @for(id_file of appModel.AdditionMandatoryFiles; track id_file){
                                <div class="imagePlaceholder"></div>
                                <b>{{id_file.name}} </b>
                                }
                            </div>
                        </div>

                    </div>
                    <div class="model-row documents">
                        <span [appTranslate]="'OTHER_DOCUMENTS'"></span>
                        <div class="flex center gap10">
                            <div class="imageWrapper">
                                @for(id_file of appModel.AdditionalFiles; track id_file){
                                <div class="imagePlaceholder"></div>
                                <b>{{id_file.name}} </b>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="agreementCheckboxes">
            <div class="form-group">
                <label class="checkbox custom-checkbox">
                    <input type="checkbox" name="agreement1" id="agreement1" [(ngModel)]="agreement1" />
                    <span class="checkbox-box"></span>
                    <span class="checkbox-label" [appTranslate]="'AGREEMENT_1'"></span>
                </label>
                <small *ngIf="!agreement1 && !fourthStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
            </div>

            <div class="form-group">
                <label class="checkbox custom-checkbox">
                    <input type="checkbox" name="agreement2" id="agreement2" [(ngModel)]="agreement2" />
                    <span class="checkbox-box"></span>
                    <span class="checkbox-label">
                        <span [appTranslate]="'AGREEMENT_2_PART1'"></span>
                        <a href="/Content/documents/{{(selectedCityNameEN | lowercase)}}/Права и обврски на корисникот и давателот на услугата паркирање.pdf"
                            target="_blank" class="agreement-link">
                            <span [appTranslate]="'AGREEMENT_2_PART2'"></span>
                        </a>
                    </span>
                </label>
                <small *ngIf="!agreement2 && !fourthStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
            </div>

            <div class="form-group">
                <label class="checkbox custom-checkbox">
                    <input type="checkbox" name="agreement3" id="agreement3" [(ngModel)]="agreement3" />
                    <span class="checkbox-box"></span>
                    <span class="checkbox-label" [appTranslate]="'AGREEMENT_3'"></span>
                </label>
                <small *ngIf="!agreement3 && !fourthStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
            </div>

            <div class="form-group">
                <label class="checkbox custom-checkbox">
                    <input type="checkbox" name="agreement4" id="agreement4" [(ngModel)]="agreement4" />
                    <span class="checkbox-box"></span>
                    <span class="checkbox-label" [appTranslate]="'AGREEMENT_4'"></span>
                </label>
                <small *ngIf="!agreement4 && !fourthStepValid" [appTranslate]="'REQUIRED_FIELD'"></small>
            </div>
        </div>

        <div class="profile-actions jusitfy-content-between">
            <button [appTranslate]="'BACK'" type="button" (click)="goToStep(3)" class="btn btn-next"
                aria-label="Back"></button>
            <button [appTranslate]="'SEND_APP'" type="button" (click)="sendApp()" [disabled]="isSubmitting"
                class="btn btn-primary" aria-label="Send application"></button>
        </div>

        <div class="errors" *ngIf="hasErrorsFinal">
            <span class="error">
                {{errorsMessagesFinal}}
            </span>
        </div>
    </div>
</div>